import React, { useRef } from "react";
import { Popover, IconButton } from "@material-ui/core";
import styled from "styled-components";

import { Icon } from "js/Components/Icon";
import { HoverHighlight } from "./HoverHighlight";

const CloseButtonContainer = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1000;
`;

const CloseButton = styled(IconButton)`
    &&& {
        padding: 8px;
    }
`;

const CompletionTitle = styled.div`
    font-family: "Source Sans Pro";
    font-size: 18px;
    font-weight: 600;
    line-height: 120%;
    letter-spacing: 0.5px;
`;

const CompletionBody = styled.div`
    font-family: "Source Sans Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%;
    letter-spacing: -0.32px;
`;

const InstructionText = styled.div`
    font-family: "Source Sans Pro";
    font-size: 16px;
    font-style: italic;
    font-weight: 400;
    line-height: 125%;
    letter-spacing: -0.32px;
`;

const QuestionMarkIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #E5E5E5;
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    color: #666666;
    margin: 0 4px;
    vertical-align: middle;
    line-height: 1;
    text-align: center;
    letter-spacing: 0;
`;

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

interface CompletedStepProps {
    open: boolean;
    onClose: () => void;
}

export const CompletedStep: React.FC<CompletedStepProps> = ({ open, onClose }) => {
    const instructionTextRef = useRef<HTMLDivElement>(null);

    if (!open) {
        return null;
    }

    return (
        <>
            <Popover
                open={open}
                onClose={onClose}
                disableEscapeKeyDown
                anchorReference="anchorPosition"
                anchorPosition={{ top: window.innerHeight - 24, left: window.innerWidth - 82 }}
                transformOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                PaperProps={{
                    style: {
                        width: 320,
                        background: "#FFFFFF",
                        borderRadius: 8,
                        boxShadow: "0 9px 37px 0 rgba(0, 0, 0, 0.20)",
                        border: "1px solid #222",
                        padding: 24,
                        position: "relative",
                        zIndex: 10
                    }
                }}
                disableRestoreFocus
            >
                <CloseButtonContainer>
                    <CloseButton
                        onClick={onClose}
                        size="small"
                    >
                        <Icon fill white medium>cancel</Icon>
                    </CloseButton>
                </CloseButtonContainer>
                <ContentContainer>
                    <CompletionTitle>
                        What else will you do?
                    </CompletionTitle>
                    <CompletionBody>
                        You've nailed the basics. Now it's time to play—add even more Smart Slides, experiment with layouts, or create your own theme. You've got this.
                    </CompletionBody>
                    <InstructionText ref={instructionTextRef}>
                        To revisit this helpful checklist, find it under the <QuestionMarkIcon>?</QuestionMarkIcon> icon.
                    </InstructionText>
                </ContentContainer>
            </Popover>
            <HoverHighlight
                target="#help-icon"
                hoverTriggerRef={instructionTextRef}
            />
        </>
    );
};

